module.exports = __webpack_public_path__ + "img/pantalla-1-4.6b992195.png";